import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { assets } from '../utils/mock';

export const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#29367A] text-white">
      <div className="w-full max-w-7xl mx-auto px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo */}
          <div>
            <img
              src={assets.footerLogo}
              alt="Savi Investing"
              className="h-28 md:h-32 object-contain"
            />
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => navigate('/')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/savi')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  About Savi
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/portfolio')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Our Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/framework')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Investing Framework
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/knowledge-centre')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Knowledge Centre
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/disclaimer')}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Disclaimer
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-white/60 flex-shrink-0 mt-0.5" />
                <span className="text-white/80">saviinvesting@gmail.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-white/60 flex-shrink-0 mt-0.5" />
                <span className="text-white/80">(91) 82408 45206</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-white/60 flex-shrink-0 mt-0.5" />
                <span className="text-white/80">
                  Room 117, Gagananchal Shopping Complex<br />
                  37 Dr. Abani Dutta Road<br />
                  Howrah - 711106, West Bengal, INDIA
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8 text-center">
          <p className="text-white/60 text-sm">
            © {currentYear} Savi Investing Pvt. Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
